import React, { useEffect, useRef, useState } from "react";
import { history } from "../../../core/helpers/history";
import { router } from "../../../core/helpers/router";
import "./PaymentIframe.scss";

interface PaymentIframeProps {
  htmlContent: string;
  url: string; // TS2322 hatasını çözmek için buraya url prop'unu ekledik
  onClose: () => void;
}

const PaymentIframe: React.FC<PaymentIframeProps> = ({
  htmlContent,
  url, // url prop'unu içeri aldık
  onClose,
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    // Mesaj dinleyici ekleme mantığı (her iki durumda da çalışır)
    const handleMessage = (event: MessageEvent) => {
      console.log("Received message from iframe:", event.data);

      if (event.data === "payment-success") {
        history.push(router.PAY_BY_ME_SUCCESS);
      } else if (event.data === "payment-failed") {
        history.push(router.PAY_BY_ME_FAILED);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []); // Bağımlılık dizisini sadeleştirdik

  const handleIframeLoad = () => {
    console.log("Iframe loaded successfully");
    setIframeLoaded(true);
  };

  return (
    <div className="payment-iframe-container">
      <div className="payment-iframe-content">
        {/* Kapatma butonu eklemek isterseniz buraya ekleyebilirsiniz */}
        <iframe
          ref={iframeRef}
          // EĞER url varsa src'yi kullan, YOKSA srcDoc üzerinden htmlContent'i bas
          src={url !== "" ? url : undefined}
          srcDoc={url === "" ? htmlContent : undefined}
          title="Payment Form"
          className={`payment-iframe ${iframeLoaded ? "loaded" : "loading"}`}
          sandbox="allow-forms allow-scripts allow-same-origin allow-popups allow-modals"
          onLoad={handleIframeLoad}
        />
      </div>
    </div>
  );
};

export default PaymentIframe;